import { __ } from '@wordpress/i18n'
import { countries } from '../shared/countries'

const toOption = str => ({ value: str, label: str })
export default {
  labels: {
    company: __('Firma', 'dhsv_theme'),
    name: __('Name', 'dhsv_theme'),
    street: __('Straße & Hausnummer', 'dhsv_theme'),
    postalcodeCity: __('Postleitzahl & Ort', 'dhsv_theme'),
    country: __('Land', 'dhsv_theme'),
    phone: __('Telefon', 'dhsv_theme'),
    email: __('E-Mail', 'dhsv_theme'),
    subject: __('Betreff', 'dhsv_theme'),
    message: __('Ihre Nachricht an uns', 'dhsv_theme'),
    gdpr: __(
      'Ich habe die <a target="_blank" href="/datenschutz">Datenschutzerklärung</a> gelesen und stimme der Verarbeitung meiner Daten zu.',
      'dhsv_theme'
    ),
    submit: __('Abschicken', 'dhsv_theme'),
  },
  validationMessages: {
    email: __('Bitte geben Sie eine gültige E-Mail-Adresse an', 'dhsv_theme'),
    required: __('Bitte füllen Sie das Feld aus', 'dhsv_theme'),
    gdpr: __('Bitte stimmen Sie der Übermittlung Ihrer Daten zu', 'dhsv_theme'),
  },
  selectOptions: {
    subjects: [
      __('Trainings', 'dhsv_theme'),
      __('Fachhandelspartnerschaft', 'dhsv_theme'),
      __('Distributionsanfrage', 'dhsv_theme'),
      __('Stellenangebot', 'dhsv_theme'),
      __('Sonstiges', 'dhsv_theme'),
    ].map(toOption),
    countries: Object.values(countries).map(toOption),
  },
}
